import { OrderFile } from '../models';
import { useCollection } from './useCollection';

export function useOrderFiles(orderId: string) {
  return useCollection<OrderFile>(`Orders/${orderId}/OrderFiles`, []);
}
